import { render } from "./closeProject.vue?vue&type=template&id=69ca78f2"
import script from "./closeProject.vue?vue&type=script&lang=js"
export * from "./closeProject.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__